import { useMediaQuery, Typography, Box, Button } from '@mui/material';
import { ReactComponent as Check } from './checkfilled.svg';

const useStyles = () => ({
  container: {
    width: '100%',
    height: { xxs: '74px', sm: '50px' },
    zIndex: 1000,
    position: 'fixed',
  },
  fixedContainer: {
    width: '100%',
    height: { xxs: '74px', sm: '50px' },
    backgroundColor: '#3171F6',
    '&:hover': { backgroundColor: '#3171F6' },
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
  },
  icon: {
    color: '#19AD6E',
    height: '25px',
    width: '25px',
    marginTop: '-5px',
    marginLeft: '-7px',
  },
  background: {
    backgroundColor: 'transparent',
    height: '11px',
    width: '11px',
    marginRight: '15px',
    marginTop: '-5px',
    overflow: 'display',
  },
  text: {
    color: 'white',
    textAlign: 'center',
    fontWeight: 700,
  },
  hide: {
    display: 'none',
  },
});

function ExFreemiumBanner(props) {
  const { show } = props;
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const classes = useStyles();

  return (
    <Box sx={show ? classes.container : classes.hide} id="B2BonboardingBanner">
      <Button type="button" sx={classes.fixedContainer} disableRipple>
        <Box sx={classes.background}>
          {!isSM && <Check style={classes.icon} />}
        </Box>
        <Typography variant="h3" sx={classes.text}>
          Your profile is under review! Once you've completed your onboarding
          call your profile can go live.
        </Typography>
      </Button>
    </Box>
  );
}

export default ExFreemiumBanner;
